export const leadsStatus: {
  id: number;
  label: string;
  btnClass: string;
  class: string;
}[] = [
  {
    id: 0,
    label: 'Process initiated',
    btnClass: 'btn-light',
    class: 'lnr lnr-hourglass'
  },
  {
    id: 1,
    label: 'Contacted',
    btnClass: 'v-btn-warning',
    class: 'lnr lnr-phone v-text-warning'
  },
  {
    id: 2,
    label: 'Completed',
    btnClass: 'v-btn-success',
    class: 'lnr lnr-check v-text-success'
  }
];
